import { Controller } from "@hotwired/stimulus"

// Type-to-confirm gate for the "Delete this draft?" modal. The destructive
// button (target: confirm) stays disabled until the text typed into the input
// (target: input) matches the expected phrase (the event title), compared
// case-insensitively and trimmed. Stops an accidental one-click delete from
// irreversibly destroying a configured draft.
//
//   data-controller="delete-confirm"
//   data-delete-confirm-match-value="<event title>"
//   <input data-delete-confirm-target="input" data-action="input->delete-confirm#check">
//   <button data-delete-confirm-target="confirm" disabled>
export default class extends Controller {
  static targets = ["input", "confirm"]
  static values = { match: String }

  connect() {
    this.check()
    // Focus the input so confirming is one keystroke away (keyboard users + speed).
    this.inputTarget?.focus()
  }

  check() {
    const typed = (this.inputTarget.value || "").trim().toLowerCase()
    const expected = (this.matchValue || "").trim().toLowerCase()
    this.confirmTarget.disabled = typed === "" || typed !== expected
  }

  // Block an Enter keypress in the input from submitting while still disabled.
  submitIfMatched(event) {
    if (this.confirmTarget.disabled) event.preventDefault()
  }
}
